import { ComponentStyleConfig, createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { inputAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle } = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    color: 'text.main',
    borderColor: 'gray.500',
  },
});

export const input: ComponentStyleConfig = {
  defaultProps: {
    focusBorderColor: 'brand.300',
  },
  baseStyle,
};
